import * as actionTypes from "../constants";
import { parseServiceErrors } from "../services/encounter/serviceErrors";
import { userPreferencesAPI } from "../services/userPreferences";

import { addErrorsAction } from "./errors";

import type { UserPreferencesEntity } from "../models";

export const setUserPreferenceAction = (preference: string, value: any) => (dispatch) => {
  dispatch(setUserPreferenceBegin());

  userPreferencesAPI
    .setPreference(preference, value)
    .then((userPreference) => {
      dispatch(setUserPreferenceCompleted(userPreference));
    })
    .catch((reason) => {
      const errors = parseServiceErrors(reason, "Error Setting User Preference");
      dispatch(addErrorsAction(errors));
      dispatch(setUserPreferenceError(reason));
    });
};

const setUserPreferenceBegin = () => ({
  type: actionTypes.SET_USER_PREFERENCE_BEGIN,
});

const setUserPreferenceCompleted = (userPreference: UserPreferencesEntity) => ({
  payload: userPreference,
  type: actionTypes.SET_USER_PREFERENCE_COMPLETED,
});

const setUserPreferenceError = (error: string) => ({
  payload: error,
  type: actionTypes.SET_USER_PREFERENCE_ERROR,
});
